<template>
  <div class="relative w-full px-2 mb-6 z-10">
    <div class="absolute pin-b mb-10 p-2 bg-white center-r with-tooltip rounded border-top border-bottom border-right border-left border-r-4 border-b-4" style="width: 130%">
      <div class="popup-inner overflow-y-scroll bg-white">
        <div class="text-left text-grey-dark text-xs">
          <div v-for="(group, key) in options" :key="key">
            <div class="border-bottom flex flex-wrap w-full">
              <div class="py-4 px-2 items-center " :class="object.class? object.class : 'w-1/3'" v-for="(object,key1) in group" v-if="object.value!='line'" :key="key1">
                <input type="checkbox" class="green" :id="'triggerOption_' + name + '_' +object.value" :value="object.value" :name="name+'[]'" v-model="selectedTriggers" onclick="event.preventDefault()">
                <label :for="'triggerOption_' + name + '_' +object.value" @click="changeValue(object.value)"></label>
                <span>{{ object.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'options',
    'selected',
    'name'
  ],
  watch: {
  },
  data () {
    return {
      selectedTriggers: []
    }
  },
  methods: {
    changeValue (value) {
      if (value === 'all') {
        var selectedAll = this.selectedTriggers.includes('all')
        if (!selectedAll) {
          // select all options
          for (var groupIndex in this.options) {
            for (var elementIndex in this.options[groupIndex]) {
              var element = this.options[groupIndex][elementIndex]
              if (!this.selectedTriggers.includes(element.value)) {
                this.selectedTriggers.push(element.value)
              }
            }
          }
        } else {
          // deselect all options
          // eslint-disable-next-line no-redeclare
          for (var groupIndex in this.options) {
            // eslint-disable-next-line no-redeclare
            for (var elementIndex in this.options[groupIndex]) {
              // eslint-disable-next-line no-redeclare
              var element = this.options[groupIndex][elementIndex]
              this.selectedTriggers = this.removeFromArray(element.value, this.selectedTriggers)
            }
          }
        }
      } else if (value === 'aps') {
        var selectAPS = this.selectedTriggers.includes('aps')
        var apsGroup = this.options['apsGroup']
        if (!selectAPS) {
          this.selectedTriggers.push('aps')
          // deselect ptm
          for (var ptmIndex in this.options['ptmGroup']) {
            var PtmElement = this.options['ptmGroup'][ptmIndex]
            this.selectedTriggers = this.removeFromArray(PtmElement.value, this.selectedTriggers)
          }
          // select all aps group options
          // eslint-disable-next-line no-redeclare
          for (var elementIndex in apsGroup) {
            // eslint-disable-next-line no-redeclare
            var element = apsGroup[elementIndex]
            if (!this.selectedTriggers.includes(element.value)) {
              this.selectedTriggers.push(element.value)
            }
          }
        } else {
          // remove all and aps
          this.selectedTriggers = this.removeFromArray('all', this.selectedTriggers)
          this.selectedTriggers = this.removeFromArray('aps', this.selectedTriggers)
          // eslint-disable-next-line no-redeclare
          for (var elementIndex in apsGroup) {
            // eslint-disable-next-line no-redeclare
            var element = apsGroup[elementIndex]
            this.selectedTriggers = this.removeFromArray(element.value, this.selectedTriggers)
          }
        }
      } else {
        if (!this.selectedTriggers.includes(value)) {
          this.selectedTriggers.push(value)
        } else {
          this.selectedTriggers = this.removeFromArray(value, this.selectedTriggers)
          // also deselect 'all'
          this.selectedTriggers = this.removeFromArray('all', this.selectedTriggers)
        }
      }
      this.$emit('change', this.selectedTriggers)
    },
    removeFromArray (needle, orginArray) {
      var index = orginArray.indexOf(needle)
      if (index !== -1) {
        orginArray.splice(index, 1)
      }
      return orginArray
    }
  },
  mounted () {
    this.selectedTriggers = this.selected.length > 0 ? JSON.parse(JSON.stringify(this.selected)) : []
  }
}
</script>
